import { Route, Routes } from "react-router-dom";
import About from "./component/About/About";
import AddToCart from "./component/AddToCart/AddToCart";
import Blogs from "./component/Blogs/Blogs";
import "bootstrap/dist/css/bootstrap.min.css";
import Home from "./component/Home/Home";

import Services from "./component/Services/Services";
import RequireAuth from "./RequireAuth/RequireAuth";

import NotFound from "./component/NotFound/NotFound";
import Navbarr from "./component/Navbarr/Navbarr";
import Regester from "./Regester/Regester";
import Login from "./component/Login/Login";

function App() {
  return (
    <div className="App">
      {/* <Home /> */}
      <Navbarr></Navbarr>

      <Routes>
        ><Route path="/about" element={<About></About>}></Route>
        <Route path="/blogs" element={<Blogs></Blogs>}></Route>
        <Route path="/" element={<Home></Home>}></Route>
        <Route path="/services" element={<Services></Services>}></Route>
        <Route
          path="/addtocart"
          element={
            <RequireAuth>
              <AddToCart></AddToCart>
            </RequireAuth>
          }
        ></Route>
        <Route path="/regester" element={<Regester></Regester>}></Route>
        <Route path="/login" element={<Login></Login>}></Route>
        <Route path="*" element={<NotFound></NotFound>}></Route>
      </Routes>
    </div>
  );
}

export default App;
